<template>
  <div class="payment__content">
    <!-- header -->
    <div class="layer__header">
      <div class="lyr-title">{{ $t('User.Pickup.PickupCheckError.msg1') }}</div>
      <div class="ft-error">
        {{ $t('User.Pickup.PickupCheckError.msg2') }}
      </div>
    </div>
    <!-- //header -->

    <div class="payment__body">
      <div class="inner-pd">
        <span class="img-info img--error01"></span>
        <!-- <span class="img-info img--error02"></span> -->
      </div>
    </div>

    <div class="layer__button">
      <button class="btn btn--line btn--xlg btn-anim" @mouseup="$emit('closeError')">돌아{{ $t('User.Pickup.PickupCheckError.msg5') }}가기</button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'pickupCheckError',
  props: {},
  methods: {},
  data() {
    return {
      darkModeYn: this.$store.getters.getDarkModeYn,
    };
  },
  mounted() {
    this.$showButtonAnimation();
  },
  components: {},
  computed: {
    darkMode: function () {
      return this.$store.getters.getDarkModeYn;
    },
  },
  watch: {
    darkMode() {
      this.darkModeYn = this.darkModeYn ? false : true;

      this.$changeDarkMode(this.darkModeYn);
    },
  },
  updated() {
    this.$showButtonAnimation();
  },
};
</script>

<style src="@/assets/css/user/common.css" scoped></style>
<style src="@/assets/css/user/pages/payment.css" scoped></style>
<style src="@/assets/css/user/dark/common-dark.css" scoped></style>
<style src="@/assets/css/user/dark/payment-dark.css" scoped></style>
<style scoped></style>
